module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0056.jpg?v=8ce811a6";